module.exports = __webpack_public_path__ + "static/img/logo_big.9085017.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/logo_big.png
// module id = ieIS
// module chunks = 1